import Box from "@mui/material/Box";
import React from "react";

import NoteTwoToneIcon from "@mui/icons-material/NoteTwoTone";

import EmptyItem from "../../Components/EmptyItem";
import { useTranslation } from "react-i18next";

function EmptyBoard() {
  const { t } = useTranslation();
  return (
    <Box
      height={250}
      width={"100%"}
      textAlign="center"
      justifyContent="center"
      alignItems="center"
      display="flex"
    >
      <EmptyItem Icon={NoteTwoToneIcon} text={t("moodboards.placeholders.emptyBoard")} />
    </Box>
  );
}

export default EmptyBoard;
